import styled from 'styled-components';

export const ModalDynamicThemeListStyled = styled.div`
  .Polaris-DataTable table.Polaris-DataTable__Table {
    thead > tr > th:not(:first-child) {
      text-align: center;
    }
    tbody > tr > td:not(:first-child) {
      text-align: center;
    }
  }
`;
